import React, { lazy } from 'react';
import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router';

import Loadable from '../layouts/full/shared/loadable/Loadable';

import AuthGuard from 'src/guards/authGuard/AuthGuard';
import GuestGuard from 'src/guards/authGuard/GuestGaurd';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const DashboardPage = Loadable(lazy(() => import('../views/pages/dashboard/Dashboard.js')));

const EditAccountPage = Loadable(lazy(() => import('../views/pages/account-setting/AccountSetting.js')));
const ChangePasswordPage = Loadable(lazy(() => import('../views/pages/change-password/ChangePassword.js')));

const ViewCoursePage = Loadable(lazy(() => import('../views/pages/courses/ViewCourse.js')));
const CourseListPage = Loadable(lazy(() => import('../views/pages/courses/CourseListPage.js')));
const ViewLessonPage = Loadable(lazy(() => import('../views/pages/lessons/ViewLesson.js')));
const ViewExamPage = Loadable(lazy(() => import('../views/pages/exams/ViewExam.js')));

const PaymentList = Loadable(lazy(() => import('../views/pages/payments/PaymentList.js')));
const PaymentStatus = Loadable(lazy(() => import('../views/pages/payments/PaymentStatus.js')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth/Login')));
// const Register = Loadable(lazy(() => import('../views/authentication/auth/Register'))); // Disabled Action
// const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth/ForgotPassword')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

const Router = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <DashboardPage /> },

      { path: '/courses', element: <CourseListPage /> },
      { path: '/view-course/:id', element: <ViewCoursePage /> },
      { path: '/view-lesson/:lessonId/:courseId', element: <ViewLessonPage /> },
      { path: '/view-exam/:examId/:courseId', element: <ViewExamPage /> },

      { path: '/edit-account', exact: true, element: <EditAccountPage /> },
      { path: '/change-password', exact: true, element: <ChangePasswordPage /> },

      { path: '/payments', exact: true, element: <PaymentList /> },
      { path: '/payments/:id', exact: true, element: <PaymentStatus /> },

      { path: '*', element: <Error /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/auth/maintenance', element: <Maintenance /> },
      { path: '*', element: <Error /> },
    ],
  },
  {
    path: '/',
    element: (
    <GuestGuard>
      <BlankLayout />
    </GuestGuard>
    ),
    children: [
      { path: '/auth/404', element: <Error /> },
      { path: '/auth/maintenance', element: <Maintenance /> },
      { path: '/auth/login', element: <Login /> },
      // { path: '/auth/register', element: <Register /> }, // Disabled Action
      // { path: '/auth/forgot-password', element: <ForgotPassword /> },
      { path: '*', element: <Error /> },
    ],
  }
];

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter(Router);

export default router;
